import { PayrollCycle } from '@zorro/clients';
import {
  Select,
  type SelectProps,
  type SelectSize,
} from '@zorro/design-system/v2/Select';
import { getPayrollCycleLabel } from '@zorro/web/ui-utils';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, Path } from 'react-hook-form';

export const selectPayrollCycleOptions = Object.values(PayrollCycle).map(
  (payrollCycle) => ({
    label: getPayrollCycleLabel(payrollCycle),
    value: payrollCycle,
  })
);

type PayrollCycleFieldValues = { payrollCycle?: PayrollCycle | null };
type Props<T extends PayrollCycleFieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & {
  selectProps?: SelectProps;
  size?: SelectSize;
};

export const PayrollCycleInput = forwardRef(
  <T extends PayrollCycleFieldValues, U extends Path<T>>(
    { selectProps, size = 'lg', ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Select
        {...field}
        {...selectProps}
        ref={ref}
        size={size}
        label="Payroll cycle"
        placeholder="Payroll cycle"
        data={selectPayrollCycleOptions}
      />
    );
  }
);

PayrollCycleInput.displayName = 'PayrollCycleInput';
